import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./FAQs.css";

const faqs = [
  {
    question: "What is the Golden Triangle Tour in India?",
    answer:
      "The Golden Triangle Tour is India’s most popular travel circuit covering Delhi, Agra, and Jaipur. It offers a perfect introduction to India’s history, culture, architecture, and royal heritage.",
  },
  {
    question: "How many days are required for a Golden Triangle Tour?",
    answer:
      "A typical Golden Triangle Tour takes 4 to 6 days. However, itineraries can be customized depending on your travel schedule and sightseeing preferences.",
  },
  {
    question: "What destinations are included in the Golden Triangle?",
    answer:
      "The tour includes Delhi (capital city sightseeing), Agra (home of the Taj Mahal), and Jaipur (the Pink City famous for forts and palaces).",
  },
  {
    question: "What is the best time to visit the Golden Triangle?",
    answer:
      "The best time to travel is from October to March when the weather is pleasant for sightseeing across Delhi, Agra, and Jaipur.",
  },
  {
    question: "Is the Golden Triangle Tour suitable for first-time visitors to India?",
    answer:
      "Yes, it is highly recommended for first-time travelers as it showcases India’s top cultural landmarks, historical monuments, and vibrant local experiences.",
  },
  {
    question: "Are budget Golden Triangle packages available?",
    answer:
      "Yes, we offer budget-friendly packages including comfortable hotels, private transportation, guided sightseeing, and customizable itineraries.",
  },
  {
    question: "Is transportation included in the tour package?",
    answer:
      "Yes, all packages include private air-conditioned vehicles with experienced drivers for intercity travel and local sightseeing.",
  },
  {
    question: "Can I customize my Golden Triangle itinerary?",
    answer:
      "Absolutely! You can extend your trip with destinations like Ranthambore, Varanasi, Udaipur, or Goa based on your interests.",
  },
  {
    question: "Are guides available during sightseeing?",
    answer:
      "Yes, professional English-speaking local guides are available at major monuments to enhance your travel experience.",
  },
  {
    question: "Is the Golden Triangle Tour safe for families and solo travelers?",
    answer:
      "Yes, the Golden Triangle is one of India’s safest and most tourist-friendly routes, suitable for families, couples, and solo travelers.",
  },
];

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="andaman-faq-section">
      
      {/* Floating Decor */}
      <div className="floating-decor leaf"></div>

      <div className="andaman-faq-hero">
        <h1>Golden Triangle Tour FAQs</h1>
        <p>
          Planning your Delhi, Agra, and Jaipur trip? Here are answers to the most
          common questions to help you plan a smooth and unforgettable Golden
          Triangle journey.
        </p>
      </div>

      <div className="andaman-faq-container">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`andaman-faq-card ${
              activeIndex === index ? "active" : ""
            }`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="andaman-faq-question">
              <h3>{faq.question}</h3>
              <FaChevronDown
                className={`icon ${activeIndex === index ? "rotate" : ""}`}
              />
            </div>

            <div
              className="andaman-faq-answer"
              style={{
                maxHeight: activeIndex === index ? "200px" : "0",
                opacity: activeIndex === index ? "1" : "0",
              }}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Shape */}
      <div className="andaman-wave"></div>
    </section>
  );
};

export default FAQs;